import { render, staticRenderFns } from "./ToDownLoadTab.vue?vue&type=template&id=49fed22b&scoped=true&"
import script from "./ToDownLoadTab.vue?vue&type=script&lang=js&"
export * from "./ToDownLoadTab.vue?vue&type=script&lang=js&"
import style0 from "./ToDownLoadTab.vue?vue&type=style&index=0&id=49fed22b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fed22b",
  null
  
)

export default component.exports